module.exports = __webpack_public_path__ + "1d73e6ca0eece647452dcdd119ce61eb.svg";